// @flow

import adobeAnalytics from './AppMeasurement';
import format from 'date-fns/format';
import assign from 'lodash/assign';

export let analytics: Object | null = null;

const getTime = () => format(new Date(), 'dd-MM-yyyy HH:mm:SS');

//test: danskebprod, propd: dbgdanskebankdkhomepage
export function initializeAnalytics(rsid: string, id: string, domain: ?string) {
  analytics = adobeAnalytics(rsid);
  analytics.charSet = 'utf-8';
  analytics.server = id;
  analytics.visitorNamespace = 'danskebank';
  analytics.dc = 112;
  if (domain) {
    analytics.trackingServer = `p1.${domain}`;
    analytics.trackingServerSecure = `p2.${domain}`;
  }
}

export function trackPageChange(pageName: string) {
  if (analytics === null) {
    throw new Error('initializeAnalytics have not been called yet');
  }

  if (analytics !== null) {
    clearFields();
    analytics.prop45 = getTime();
    analytics.pageName = pageName;
    analytics.t();
  }
}

export function trackAction(
  pageName: string,
  actionId: string,
  data: Object = {}
) {
  if (analytics !== null) {
    clearFields();
    analytics.prop45 = getTime();
    analytics.pageName = `${actionId} - ${pageName}`;
    updateAnalyticsData(data);
    analytics.t();
  }
}

function updateAnalyticsData(data = {}) {
  if (analytics === null) {
    throw new Error('initializeAnalytics have not been called yet');
  }

  if (analytics !== null) {
    assign(analytics, data);
  }
}

function clearFields() {
  if (analytics !== null) {
    analytics.campaign = '';
    analytics.eVar1 = '';
    analytics.eVar2 = '';
    analytics.eVar3 = '';
    analytics.eVar20 = '';
    analytics.eVar21 = '';
    analytics.eVar22 = '';
    analytics.eVar23 = '';
    analytics.prop9 = '';
    analytics.prop10 = '';
    analytics.prop11 = '';
    analytics.prop12 = '';
    analytics.prop13 = '';
    analytics.prop14 = '';
    analytics.prop20 = '';
    analytics.prop21 = '';
    analytics.prop22 = '';
    analytics.prop23 = '';
    analytics.events = '';
    analytics.products = '';
  }
}
